import Swiper from "swiper/bundle";
// import "swiper/css";
// import "swiper/css/bundle";

export const slider = {
  init() {
    this.news();
    this.recipe();
  },

  news() {
    const sliders = document.querySelectorAll(".section-news .swiper");

    sliders.forEach((slider) => {
      const slideCount = slider.querySelectorAll(".swiper-slide").length;

      new Swiper(slider, {
        loop: false,
        slidesPerView: 1.8,
        spaceBetween: 8,
        breakpoints: {
          769: {
            centeredSlides: false,
            spaceBetween: 20,
            slidesPerView: "auto",
            loop: slideCount > 3,
          },
        },
      });
    });
  },

  recipe() {
    const sliders = document.querySelectorAll(".section-post .swiper");

    sliders.forEach((slider) => {
      const initSwiper = () => {
        const createSwiper = () => {
          return new Swiper(slider, {
            slidesPerView: 1.4,
            watchSlidesProgress: true,
            spaceBetween: 10,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            centeredSlides: true,
            initialSlide: 1,
            pagination: {
              el: slider.querySelector(".post__list-nav__pagination"),
              clickable: true,
            },
            navigation: {
              nextEl: slider.querySelector(".post__list-nav__button--next"),
              prevEl: slider.querySelector(".post__list-nav__button--prev"),
            },
          });
        };

        const destroySwiper = (swiper) => {
          if (swiper) {
            swiper.destroy(true, true);
          }
        };

        let swiper = null;

        const handleResize = () => {
          if (window.innerWidth < 768) {
            if (!swiper) {
              swiper = createSwiper();
            }
          } else {
            destroySwiper(swiper);
            swiper = null;
          }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
      };

      // 初期化
      initSwiper();
    });
  },
};
